import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import dashboard from "../Images/signup_image.png";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TextField, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import { FaTrash } from "react-icons/fa";
import Checkbox from "@mui/material/Checkbox";

const Signup = () => {
  const navigate = useNavigate();
  const storedCountry = sessionStorage.getItem("country");
  const storedStates = JSON.parse(sessionStorage.getItem("state")) || [];
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [teamStrength, setTeamStrength] = useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  const [companyStartDate, setCompanyStartDate] = useState(null);
  const [gmbProfileUrl, setGmbProfileUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [businessMailId, setBusinessMailId] = useState("");
  const [projectArea, setProjectArea] = useState("");
  const [projectType, setProjectType] = useState("");
  const [projectValue, setProjectValue] = useState("");
  const [nearByLocation, setNearByLocation] = useState("");
  const [amenities, setAmenities] = useState("");
  const [cmdaReraApproved, setcmdaReraApproved] = useState("");
  const [projectPhotos, setProjectPhotos] = useState(null);
  const [brochureUpload, setBrochureUpload] = useState([]);
  const [previewProjectPhotos, setPreviewProjectPhotos] = useState(null);
  const [previewBrochureUpload, setPreviewBrochureUpload] = useState([]);

  //  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setUserName(sessionStorage.getItem("name") || "");
    setUserEmail(sessionStorage.getItem("email") || "");
    setUserPhoneNumber(sessionStorage.getItem("number") || "");
    setUserCompany(sessionStorage.getItem("brand") || "");
  }, []);

  const handleProjectPhotosChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProjectPhotos(file);
      const previewUrl = URL.createObjectURL(file);
      setPreviewProjectPhotos(previewUrl);
    }
  };

  const handleBrochureUploadChange = (e) => {
    const files = Array.from(e.target.files);
    setBrochureUpload(files);
    const previewUrls = files.map((file) => URL.createObjectURL(file));
    setPreviewBrochureUpload(previewUrls);
  };

  const handleSubmit = async () => {
    const finalFormID = parseInt(sessionStorage.getItem("finalFormID"), 10);
    const serviceid = parseInt(sessionStorage.getItem("serviceid"), 10);

    setIsLoading(true);

    // Create a new FormData object
    const formData = new FormData();
    formData.append("name", userName);
    formData.append("email", userEmail);
    formData.append("mobileNo", userPhoneNumber);
    formData.append("companyName", userCompany);
    formData.append("location", companyLocation);
    formData.append("country", storedCountry);
    formData.append("state", storedStates);
    formData.append("initialUserId", finalFormID);
    formData.append("category", serviceid);
    formData.append("projectArea", projectArea);
    formData.append("projectValue", projectValue);
    formData.append("projectType", projectType);
    formData.append("nearbyLocation", nearByLocation);
    formData.append("amenities", amenities);
    // formData.append('cmdaReraApproved', cmdaReraApproved);
    formData.append("cmdaReraApproved", null);

    // Append project photo (single image)
    if (projectPhotos) {
      formData.append("projectPhoto", projectPhotos); // projectPhotos is a file object
    }

    // Append brochure files (multiple files)
    brochureUpload.forEach((file) => {
      formData.append("brochureCreatives", file); // file is the actual file object
    });

    // **Log FormData contents for debugging**
    console.log("FormData contents:");
    formData.forEach((value, key) => {
      if (value instanceof File) {
        console.log(`${key}: ${value.name}`); // Log the file name (not the entire file object)
      } else {
        console.log(`${key}: ${value}`);
      }
    });
    ////////////////////////////////////////////check heeeeeeeeeeerrrrrrrrrrreeeeeeeeeeeeee//////////////////
    try {
      const response = await fetch(
        `https://verse.blaccdot.com/ldsbackendindia/auth/register`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (response.ok) {
        const data = await response.json();

        // Display success message and save relevant data to sessionStorage
        toast.success("Business registered successfully", {
          duration: 3000,
          position: "top-right",
          style: { background: "green", color: "white" },
        });

        // Store data for future use (like token, userId, etc.)
        const maintoken = data?.data?.verificationToken;
        const userId = data?.data?.userId;
        sessionStorage.setItem("userId", userId);
        sessionStorage.setItem("Token", maintoken);
        sessionStorage.setItem("MyCompanay", userCompany);

        // Redirect to another page after a delay
        // setTimeout(() => {
        //   navigate("/blaccdot-pricing");
        // }, 3000);

        setTimeout(() => {
          navigate("/payment");
        }, 3000);
      } else {
        // Handle any errors if the response is not ok
        const errorData = await response.json();
        toast.error(errorData.message || "Signup failed. Please try again.", {
          duration: 3000,
          position: "top-right",
          style: { background: "#F4405F", color: "white" },
        });
      }
    } catch (error) {
      // Catch any errors during the fetch request
      toast.error("Something went wrong. Please try again.", {
        duration: 3000,
        position: "top-right",
        style: { background: "#F4405F", color: "white" },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleRemoveImage = () => {
    setPreviewProjectPhotos(null);
  };

  return (
    <div>
      <Toaster />
      <Row>
        {/* Left Column (Sticky) */}
        <Col md={7} className="sign-up-image">
          <div
            style={{
              backgroundColor: "#F7F9FC",
              position: "sticky",
              top: "0",
              height: "100vh",
            }}
          >
            <div className="pt-5">
              <div style={styles.cardContainer}>
                <h5 style={styles.quote}>
                  "Few things make me feel more powerful than setting up
                  automations in Untitled to make my life easier and more
                  efficient."
                </h5>
                {/* <p style={styles.author}>
            — Aliah Lane <br />
            <span style={styles.position}>Founder, Layers.io</span>
          </p> */}
              </div>
            </div>
            <div style={{ textAlign: "end" }}>
              <img
                style={{
                  width: "90%",
                  objectFit: "cover",
                  borderRadius: "20px 0px 0px 20px",
                  border: "3px solid #757575",
                  borderRight: "none",
                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                }}
                src={dashboard}
                alt="dashboard"
              />
            </div>
          </div>
        </Col>

        {/* Right Column (Scrollable Content) */}
        <Col md={5} style={{ height: "100vh", overflowY: "auto" }}>
          <div>
            <div className="signup-container">
              <div className="steps-navigation">
                <span className="step active">
                  <span className="circleProcess">1</span> Sign Up
                </span>
                <span className="separator" style={{ color: "#959595" }}>
                  <ChevronRightIcon />
                </span>
                <span className="step" style={{ color: "#959595" }}>
                  <span className="circleProcessnon">2</span> Payment
                </span>
                <span className="separator" style={{ color: "#959595" }}>
                  <ChevronRightIcon />
                </span>
                <span className="step" style={{ color: "#959595" }}>
                  <span className="circleProcessnon">3</span> Access dashboard
                </span>
              </div>

              <div className="account-section">
                <h2>Create your account</h2>
                <p>
                  Grow your real estate business by 15–30% through smart
                  conversations
                </p>
              </div>

              <div>
                <form>
                  <TextField
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    sx={{ width: "100%" }}
                    label="Full Name"
                    variant="standard"
                  />
                  <TextField
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Business Mail ID"
                    variant="standard"
                  />
                  <TextField
                    value={userPhoneNumber}
                    onChange={(e) => setUserPhoneNumber(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Phone Number"
                    variant="standard"
                  />
                  <TextField
                    value={userCompany}
                    onChange={(e) => setUserCompany(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Company Name"
                    variant="standard"
                  />
                  <TextField
                    value={companyLocation}
                    onChange={(e) => setCompanyLocation(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Company Location"
                    variant="standard"
                  />
                  <TextField
                    value={projectArea}
                    onChange={(e) => setProjectArea(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Project Area"
                    variant="standard"
                  />

                  <FormControl>
                    <FormLabel
                      className="mt-4"
                      id="demo-row-radio-buttons-group-label"
                    >
                      Project Type
                    </FormLabel>
                    <RadioGroup
                      onChange={(e) => setProjectType(e.target.value)}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="Plot"
                        control={<Radio />}
                        label="Plot"
                      />
                      <FormControlLabel
                        value="Flat/Apartment"
                        control={<Radio />}
                        label="Flat / Apartment"
                      />
                      <FormControlLabel
                        value="Villa"
                        control={<Radio />}
                        label="Villa"
                      />
                    </RadioGroup>
                  </FormControl>

                  <TextField
                    value={projectValue}
                    onChange={(e) => setProjectValue(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Unit Value"
                    variant="standard"
                  />

                  <TextField
                    value={nearByLocation}
                    onChange={(e) => setNearByLocation(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Nearby location"
                    variant="standard"
                  />

                  <TextField
                    value={amenities}
                    onChange={(e) => setAmenities(e.target.value)}
                    sx={{ width: "100%", marginTop: "20px" }}
                    label="Amenities"
                    variant="standard"
                  />

                  {/* <TextField
        value={cmdaReraApproved}
        onChange={(e) => setcmdaReraApproved(e.target.value)}
        sx={{ width: '100%', marginTop: '20px' }}
        label="Project Area"
        variant="standard"/> */}

                  {/* <FormControl>
      <FormLabel className='mt-4' id="demo-row-radio-buttons-group-label">Project Type</FormLabel>
      <RadioGroup value={cmdaReraApproved} onChange={(e) => setcmdaReraApproved(e.target.value)} row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
        <FormControlLabel value="CMDA" control={<Radio />} label="CMDA" />
        <FormControlLabel value="RERA" control={<Radio />} label="RERA" />
      </RadioGroup>
    </FormControl> */}

                  {/* Project Photos Upload */}
                  {/* <p className='mt-4' style={{color:'#666666'}} >Upload Project Photos</p>
           <div style={{ marginTop: '20px' }}>
          <input
            type="file"
            accept="image/*"
            onChange={handleProjectPhotosChange}
          />
          {previewProjectPhotos && (
            <div>
              <img
                src={previewProjectPhotos}
                alt="Project Photo Preview"
                style={{ marginTop: '10px', width: '100px', height: '100px' }}
              />
            </div>
          )}
        </div> */}
                  <div className="mt-3">
                    <p style={{ color: "#666666" }}>Project photo (optional)</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleProjectPhotosChange}
                      style={{ display: "none" }}
                      id="project-photo"
                    />

                    <label htmlFor="project-photo" style={styles.uploadBtn}>
                      Upload Project Photo
                    </label>

                    {/* File Preview */}
                    {previewProjectPhotos && projectPhotos && (
                      <div style={styles.previewBox}>
                        <img
                          src={previewProjectPhotos}
                          alt="Preview"
                          style={styles.imageThumb}
                        />
                        <span style={styles.fileName}>
                          {projectPhotos.name}
                        </span>
                        <FaTrash
                          style={styles.deleteIcon}
                          onClick={() => {
                            setProjectPhotos(null);
                            setPreviewProjectPhotos("");
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* Brochure Upload
        <div style={{ marginTop: '20px' }}>
        <p className='mt-4'  style={{color:'#666666'}}>Upload Brochure </p>
          <input
            type="file"
            multiple
            accept="image/*,application/pdf"
            onChange={handleBrochureUploadChange}
          />
          {previewBrochureUpload.length > 0 && (
            <div>
              {previewBrochureUpload.map((url, index) => (
                <div key={index}>
                  <img
                    src={url}
                    alt={`Brochure Preview ${index}`}
                    style={{ marginTop: '10px', width: '100px', height: '100px' }}
                  />
                </div>
              ))}
            </div>
          )}
        </div> */}

                  {/* Brochure Upload */}
                  <div style={{ marginTop: "15px" }}>
                    <p style={{ color: "#666666" }}>
                      Upload Brochure (optional)
                    </p>

                    {/* Hidden input + styled label as button */}
                    <input
                      type="file"
                      multiple
                      accept="image/*,application/pdf"
                      onChange={handleBrochureUploadChange}
                      style={{ display: "none" }}
                      id="brochure-upload"
                    />
                    <label htmlFor="brochure-upload" style={styles.uploadBtn}>
                      Select Brochures
                    </label>

                    {/* File preview section */}
                    {previewBrochureUpload.length > 0 && (
                      <div
                        style={{
                          marginTop: "12px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {previewBrochureUpload.map((url, index) => (
                          <div key={index} style={styles.previewBox}>
                            {/* Image or PDF icon */}
                            {brochureUpload[index]?.type?.includes("pdf") ? (
                              <img
                                src="/pdf-icon.png" // Replace with your actual icon path
                                alt="PDF"
                                style={styles.imageThumb}
                              />
                            ) : (
                              <img
                                src={url}
                                alt={`Brochure ${index}`}
                                style={styles.imageThumb}
                              />
                            )}

                            {/* File Name */}
                            <span style={styles.fileName}>
                              {brochureUpload[index]?.name ||
                                `File ${index + 1}`}
                            </span>

                            {/* Delete icon */}
                            <FaTrash
                              style={styles.deleteIcon}
                              onClick={() => {
                                const updatedFiles = [...brochureUpload];
                                const updatedPreviews = [
                                  ...previewBrochureUpload,
                                ];
                                updatedFiles.splice(index, 1);
                                updatedPreviews.splice(index, 1);
                                setBrochureUpload(updatedFiles);
                                setPreviewBrochureUpload(updatedPreviews);
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div>
                    <Button
                      onClick={handleSubmit}
                      disabled={isLoading}
                      sx={{ marginTop: "20px", width: "100%" }}
                      variant="contained"
                    >
                      {isLoading ? (
                        <CircularProgress size={24} sx={{ color: "white" }} />
                      ) : (
                        "Signup"
                      )}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const styles = {
  cardContainer: {
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "600px",
    margin: "0px auto",
    textAlign: "start",
    fontFamily: "Arial, sans-serif",
  },
  quote: {
    fontSize: "25px",
    color: "#333",
    marginBottom: "20px",
  },
  author: {
    fontSize: "16px",
    color: "#555",
    fontWeight: "bold",
  },
  position: {
    fontSize: "14px",
    color: "#777",
  },

  uploadBtn: {
    display: "inline-block",
    padding: "10px 18px",
    backgroundColor: "#ffff",
    color: "#1F1F1F",
    border: "1px solid #D9D9D9",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "15px",
  },
  previewBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px",
    maxWidth: "400px",
    gap: "12px",
    backgroundColor: "#f9f9f9",
    marginTop: "10px",
  },
  imageThumb: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    borderRadius: "4px",
  },
  fileName: {
    flex: 1,
    color: "#1a73e8",
    fontSize: "14px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  deleteIcon: {
    color: "#888",
    cursor: "pointer",
    fontSize: "16px",
  },
};

export default Signup;

// import React, { useEffect , useState} from 'react'
// import {Row,Col,Form} from 'react-bootstrap'
// import dashboard from '../Images/signup_image.png';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import {TextField,CircularProgress} from '@mui/material';
// import Button from '@mui/material/Button';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import {useNavigate} from 'react-router-dom';
// import { Toaster, toast } from 'react-hot-toast';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormControl from '@mui/material/FormControl';
// import FormLabel from '@mui/material/FormLabel';
// import FormGroup from '@mui/material/FormGroup';
// import Checkbox from '@mui/material/Checkbox';

// const Signup = () => {

//       const navigate = useNavigate()
//       const storedCountry = sessionStorage.getItem('country');
//       const storedStates = JSON.parse(sessionStorage.getItem('state')) || [];
//       const [userName, setUserName] = useState('');
//       const [userEmail, setUserEmail] = useState('');
//       const [userPhoneNumber, setUserPhoneNumber] = useState('');
//       const [userCompany, setUserCompany] = useState('');
//       const [teamStrength, setTeamStrength] = useState('');
//       const [companyLocation, setCompanyLocation] = useState('');
//       const [companyStartDate, setCompanyStartDate] = useState(null);
//       const [gmbProfileUrl, setGmbProfileUrl] = useState('');
//       const [isLoading, setIsLoading] = useState(false)
//       const [error, setError] = useState(false);
//       const [businessMailId, setBusinessMailId] = useState('');
//       const [projectArea, setProjectArea] = useState('')
//       const [projectType, setProjectType] = useState('')
//       const [projectValue, setProjectValue] = useState('')
//       const [nearByLocation, setNearByLocation] = useState('')
//       const [amenities, setAmenities] = useState('')
//       const [cmdaReraApproved, setcmdaReraApproved] = useState('')
//       const [projectPhotos, setProjectPhotos] = useState(null);
//       const [brochureUpload, setBrochureUpload] = useState([]);
//       const [previewProjectPhotos, setPreviewProjectPhotos] = useState(null);
//       const [previewBrochureUpload, setPreviewBrochureUpload] = useState([]);

//     //  const { enqueueSnackbar } = useSnackbar();

//       useEffect(()=>{
//         setUserName(sessionStorage.getItem('name') || '');
//         setUserEmail(sessionStorage.getItem('email') || '');
//         setUserPhoneNumber(sessionStorage.getItem('number') || '');
//         setUserCompany(sessionStorage.getItem('brand') || '');
//       },[])

//   const handleProjectPhotosChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setProjectPhotos(file);
//       const previewUrl = URL.createObjectURL(file);
//       setPreviewProjectPhotos(previewUrl);
//     }
//   };

//   const handleBrochureUploadChange = (e) => {
//     const files = Array.from(e.target.files);
//     setBrochureUpload(files);
//     const previewUrls = files.map(file => URL.createObjectURL(file));
//     setPreviewBrochureUpload(previewUrls);
//   };

//   const handleSubmit = async () => {
//     const finalFormID = parseInt(sessionStorage.getItem('finalFormID'), 10);
//     const serviceid = parseInt(sessionStorage.getItem('serviceid'), 10);

//     setIsLoading(true);

//     // Create a new FormData object
//     const formData = new FormData();
//     formData.append('name', userName);
//     formData.append('email', userEmail);
//     formData.append('mobileNo', userPhoneNumber);
//     formData.append('companyName', userCompany);
//     formData.append('location', companyLocation);
//     formData.append('country', storedCountry);
//     formData.append('state', storedStates);
//     formData.append('initialUserId', finalFormID);
//     formData.append('category', serviceid);
//     formData.append('projectArea', projectArea);
//     formData.append('projectValue', projectValue);
//     formData.append('projectType', projectType);
//     formData.append('nearbyLocation', nearByLocation);
//     formData.append('amenities', amenities);
//     formData.append('cmdaReraApproved', cmdaReraApproved);

//     // Append project photo (single image)
//     if (projectPhotos) {
//       formData.append('projectPhoto', projectPhotos); // projectPhotos is a file object
//     }

//     // Append brochure files (multiple files)
//     brochureUpload.forEach((file) => {
//       formData.append('brochureCreatives', file); // file is the actual file object
//     });

//     // **Log FormData contents for debugging**
//     console.log("FormData contents:");
//     formData.forEach((value, key) => {
//       if (value instanceof File) {
//         console.log(`${key}: ${value.name}`); // Log the file name (not the entire file object)
//       } else {
//         console.log(`${key}: ${value}`);
//       }
//     });

//     try {
//       const response = await fetch(`https://verse.blaccdot.com/ldsbackendindia/auth/register`, {
//         method: 'POST',
//         body: formData,
//       });

//       if (response.ok) {
//         const data = await response.json();

//         // Display success message and save relevant data to sessionStorage
//         toast.success('Business registered successfully', {
//           duration: 3000,
//           position: 'top-right',
//           style: { background: 'green', color: 'white' },
//         });

//         // Store data for future use (like token, userId, etc.)
//         const maintoken = data?.data?.verificationToken;
//         const userId = data?.data?.userId;
//         sessionStorage.setItem('userId', userId);
//         sessionStorage.setItem('Token', maintoken);
//         sessionStorage.setItem('MyCompanay', userCompany);

//         // Redirect to another page after a delay
//         setTimeout(() => {
//           navigate('/payment');
//         }, 3000);

//       } else {
//         // Handle any errors if the response is not ok
//         const errorData = await response.json();
//         toast.error(errorData.message || 'Signup failed. Please try again.', {
//           duration: 3000,
//           position: 'top-right',
//           style: { background: '#F4405F', color: 'white' },
//         });
//       }
//     } catch (error) {
//       // Catch any errors during the fetch request
//       toast.error('Something went wrong. Please try again.', {
//         duration: 3000,
//         position: 'top-right',
//         style: { background: '#F4405F', color: 'white' },
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div>
//      <Toaster/>
//   <Row>
//   {/* Left Column (Sticky) */}
//   <Col md={7} className='sign-up-image'>
//     <div style={{ backgroundColor: '#F7F9FC', position: 'sticky', top: '0', height: '100vh' }}>
//       <div className="pt-5">
//         <div style={styles.cardContainer}>
//           <h5 style={styles.quote}>
//             "Few things make me feel more powerful than setting up automations in Untitled to make my life easier and more efficient."
//           </h5>
//           <p style={styles.author}>
//             — Aliah Lane <br />
//             <span style={styles.position}>Founder, Layers.io</span>
//           </p>
//         </div>
//       </div>
//       <div style={{ textAlign: 'end' }}>
//         <img
//           style={{
//             width: '90%',
//             objectFit: 'cover',
//             borderRadius: '20px 0px 0px 20px',
//             border: '3px solid #757575',
//             borderRight: 'none',
//             boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 8px',
//           }}
//           src={dashboard}
//           alt="dashboard"
//         />
//       </div>
//     </div>
//   </Col>

//   {/* Right Column (Scrollable Content) */}
//   <Col md={5} style={{ height: '100vh', overflowY: 'auto' }}>
//     <div>
//       <div className="signup-container">
//         <div className="steps-navigation">
//           <span className="step active">
//             <span className="circleProcess">1</span> Sign Up
//           </span>
//           <span className="separator" style={{ color: '#959595' }}>
//             <ChevronRightIcon />
//           </span>
//           <span className="step" style={{ color: '#959595' }}>
//             <span className="circleProcessnon">2</span> Payment
//           </span>
//           <span className="separator" style={{ color: '#959595' }}>
//             <ChevronRightIcon />
//           </span>
//           <span className="step" style={{ color: '#959595' }}>
//             <span className="circleProcessnon">3</span> Access dashboard
//           </span>
//         </div>

//         <div className="account-section">
//           <h2>Create your account</h2>
//           <p>Increase eCommerce revenue by 15-30% with conversational commerce</p>
//         </div>

//         <div>
//         <form>
//       <TextField
//         value={userName}
//         onChange={(e) => setUserName(e.target.value)}
//         sx={{ width: '100%' }}
//         label="Full Name"
//         variant="standard"
//       />
//       <TextField
//         value={userEmail}
//         onChange={(e) => setUserEmail(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Business Mail ID"
//         variant="standard"
//       />
//       <TextField
//         value={userPhoneNumber}
//         onChange={(e) => setUserPhoneNumber(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Phone Number"
//         variant="standard"
//       />
//       <TextField
//         value={userCompany}
//         onChange={(e) => setUserCompany(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Company Name"
//         variant="standard"
//       />
//       <TextField
//         value={companyLocation}
//         onChange={(e) => setCompanyLocation(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Company Location"
//         variant="standard"
//       />
//       <TextField
//         value={projectArea}
//         onChange={(e) => setProjectArea(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Project Area"
//         variant="standard"/>

//       <FormControl>
//       <FormLabel className='mt-4' id="demo-row-radio-buttons-group-label">Project Type</FormLabel>
//       <RadioGroup onChange={(e)=>setProjectType(e.target.value)} row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
//         <FormControlLabel value="Plot" control={<Radio />} label="Plot" />
//         <FormControlLabel value="Flat/Apartment" control={<Radio />} label="Flat / Apartment" />
//         <FormControlLabel value="Villa" control={<Radio />} label="Villa" />
//       </RadioGroup>
//     </FormControl>

//     <TextField
//         value={projectValue}
//         onChange={(e) => setProjectValue(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Project Value"
//         variant="standard"/>

//     <TextField
//         value={nearByLocation}
//         onChange={(e) => setNearByLocation(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Nearby location"
//         variant="standard"/>

//     <TextField
//         value={amenities}
//         onChange={(e) => setAmenities(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Amenities"
//         variant="standard"/>

//      <TextField
//         value={cmdaReraApproved}
//         onChange={(e) => setcmdaReraApproved(e.target.value)}
//         sx={{ width: '100%', marginTop: '20px' }}
//         label="Project Area"
//         variant="standard"/>

//       <FormControl>
//       <FormLabel className='mt-4' id="demo-row-radio-buttons-group-label">Project Type</FormLabel>
//       <RadioGroup value={cmdaReraApproved} onChange={(e) => setcmdaReraApproved(e.target.value)} row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
//         <FormControlLabel value="CMDA" control={<Radio />} label="CMDA" />
//         <FormControlLabel value="RERA" control={<Radio />} label="RERA" />
//       </RadioGroup>
//     </FormControl>

//            {/* Project Photos Upload */}
//            <div style={{ marginTop: '20px' }}>
//           <input
//             type="file"
//             accept="image/*"
//             onChange={handleProjectPhotosChange}
//           />
//           {previewProjectPhotos && (
//             <div>
//               <img
//                 src={previewProjectPhotos}
//                 alt="Project Photo Preview"
//                 style={{ marginTop: '10px', width: '100px', height: '100px' }}
//               />
//             </div>
//           )}
//         </div>

//         {/* Brochure Upload */}
//         <div style={{ marginTop: '20px' }}>
//           <input
//             type="file"
//             multiple
//             accept="image/*,application/pdf"
//             onChange={handleBrochureUploadChange}
//           />
//           {previewBrochureUpload.length > 0 && (
//             <div>
//               {previewBrochureUpload.map((url, index) => (
//                 <div key={index}>
//                   <img
//                     src={url}
//                     alt={`Brochure Preview ${index}`}
//                     style={{ marginTop: '10px', width: '100px', height: '100px' }}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//       <div>
//         <Button onClick={handleSubmit} disabled={isLoading} sx={{ marginTop: '20px', width: '100%' }} variant="contained">
//          {isLoading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Signup" }
//         </Button>
//       </div>
//     </form>
//         </div>
//       </div>
//     </div>
//   </Col>
// </Row>

//     </div>
//   )
// }

// const styles = {
//     cardContainer: {
//       padding: '20px',
//       borderRadius: '8px',
//       maxWidth: '600px',
//       margin: '0px auto',
//       textAlign: 'start',
//       fontFamily: 'Arial, sans-serif',
//     },
//     quote: {
//       fontSize: '25px',
//       color: '#333',
//       marginBottom: '20px',
//     },
//     author: {
//       fontSize: '16px',
//       color: '#555',
//       fontWeight: 'bold',
//     },
//     position: {
//       fontSize: '14px',
//       color: '#777',
//     },
//   };

// export default Signup
